/* tslint:disable */
/* eslint-disable */
export enum PersonDocumentType {
  DRIVERS_LICENSE = 'DRIVERS_LICENSE',
  INDIVIDUAL_TAX_IDENTIFICATION_NUMBER = 'INDIVIDUAL_TAX_IDENTIFICATION_NUMBER',
  PASSPORT = 'PASSPORT',
  SOCIAL_SECURITY_NUMBER = 'SOCIAL_SECURITY_NUMBER',
  NATIONAL_ID_CARD = 'NATIONAL_ID_CARD'
}
